import * as z from "zod";

/**
 * Whether this team's Google Ads account is set up to send conversions to
 * Contextual, and how far that setup got.
 *
 * Each field is a distinct reason nothing would be delivered, so the section
 * can say which one rather than showing a single dead "not connected".
 */
export const getGoogleAdsContextualStatus = {
  name: "getGoogleAdsContextualStatus" as const,
  input: z.object({}),
  output: z.object({
    /** Google Ads is connected on Redo's side and has an account selected. */
    googleAdsReady: z.boolean(),
    /** A Contextual GOOGLEADS integration exists for this team. */
    integrationId: z.string().nullable(),
    /**
     * Whether Contextual will actually consider this integration. Minerva only
     * asks for filters on connected integrations, so a configured one that is
     * not connected delivers nothing while looking complete.
     */
    connected: z.boolean(),
    /** The Google Ads account Contextual will upload against. */
    customerId: z.string().nullable(),
    /**
     * Events with a conversion action resolved. Contextual drops an event with
     * no conversion action before sending, so an empty list here means nothing
     * is being delivered even when everything above is set.
     */
    resolvedEvents: z.array(z.string()),
  }),
};
